// extracted by mini-css-extract-plugin
export default {"formItemStyles":"WorkOrderTable_formItemStyles__P3Bm9"};